// extracted by mini-css-extract-plugin
export default {"tabs":"SettingsLinks_tabs__zORot","tabs_item":"SettingsLinks_tabs_item__AbnoS","tabs_item__active":"SettingsLinks_tabs_item__active__o4tB+"};